//auth
export const SHOW_LOADING = "SHOW_LOADING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const FORGOT_SUCCESS = "FORGOT_SUCCESS";
export const LOGOUT = "LOGOUT";
export const RESET_PASSWORD = "RESET_PASSWORD";

//toast
export const SHOW_TOAST = "SHOW_TOAST";

//Dashboard
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";

//admin types
export const GET_ADMIN_DATA = "GET_ADMIN_DATA"
export const CHANGE_ADMIN_PASSWORD = "CHANGE_ADMIN_PASSWORD"
export const EDIT_ADMIN_DETAIL = "EDIT_ADMIN_DETAIL"

//category Types

export const ADD_CATEGORY = "ADD_CATEGORY"

//splash type
export const GET_SPLASH_DATA = "ADD_CATEGORY"
export const ADD_SPLASH = "ADD_SPLASH"
export const EDIT_SPLASH = "EDIT_SPLASH"
export const DELETE_SPLASH_IMAGE = "DELETE_SPLASH_IMAGE"

//FiceTV type
export const GET_FICETV_DATA = "GET_FICETV_DATA"
export const DELETE_MEDIA = "DELETE_MEDIA"
export const ADD_FICETV_DATA = "ADD_FICETV_DATA"
export const EDIT_MEDIA = "EDIT_MEDIA"

//  IMMUNIZATION types
export const GET_IMMUNIZATION = "GET_IMMUNIZATION"
export const ADD_IMMUNIZATION = "ADD_IMMUNIZATION"
export const UPDATE_PROFESSIONAL_STATUS = "UPDATE_PROFESSIONAL_STATUS"
export const DELETE_IMMUNIZATION = "DELETE_IMMUNIZATION"
export const EDIT_IMMUNIZATION = "EDIT_IMMUNIZATION"
export const UPDATE_IMMUNIZATION_STATUS = "UPDATE_IMMUNIZATION_STATUS"
export const DRAG_IMMUNE = "DRAG_IMMUNE"

// FORUM TYPES
export const GET_FORUM = "GET_FORUM"
export const ADD_FORUM = "ADD_FORUM"
export const DELETE_FORUM = "DELETE_FORUM"
export const EDIT_FORUM = "EDIT_FORUM"
export const UPDATE_FROUM_STATUS = "UPDATE_FROUM_STATUS"

// bokkings types
export const GET_BOOKINGS = "GET_BOOKINGS"

//jobs types
export const GET_JOBS = "GET_JOBS"

//users types
export const GET_USER_DATA = "GET_USER_DATA"
export const GET_ALL_GENDERS = "GET_ALL_GENDERS"
export const DISABLE_USER = "DISABLE_USER"
export const DELETE_USER = "DELETE_USER"
export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS"
export const VERIFY_USERS = "VERIFY_USERS"
export const SEND_NOTIFY = "SEND_NOTIFY"
export const GET_THUMB = "GET_THUMBs"
export const GET_USER_DETAIL = "GET_USER_DETAIL"
// export const SEND_NOTIFY = "SEND_NOTIFY"

//FAQ
export const GET_QUESTION_ANSWER = "GET_QUESTION_ANSWER"
export const ADD_FAQ = "ADD_FAQ"
export const DELETE_FAQ = "DELETE_FAQ"
export const UPDATE_FAQ = "UPDATE_FAQ"

//term condition
export const GET_TERM_CONDITION = "GET_TERM_CONDITION"
export const UPDATE_TERM_CONDITION = "UPDATE_TERM_CONDITION"

//profile verification
export const GET_PROFILE_VERIFICATION = "GET_PROFILE_VERIFICATION"
export const UPDATE_VERIFICATION_IMAGE = "UPDATE_VERIFICATION_IMAGE"
export const ACTIVATE_VERIFICATION_STATUS = "ACTIVATE_VERIFICATION_STATUS"
export const DELETE_VERIFICATION_IMAGE = "DELETE_VERIFICATION_IMAGE"

export const GET_INTEREST_DATA = "GET_INTEREST_DATA"
export const ADD_INTEREST = "ADD_INTEREST"
export const UPDATE_INTEREST = "UPDATE_INTEREST"
export const UPDATE_INTEREST_STATUS = "UPDATE_INTEREST_STATUS"